import { render, staticRenderFns } from "./examenPiesShow.vue?vue&type=template&id=e81301cc&scoped=true"
import script from "./examenPiesShow.vue?vue&type=script&lang=js"
export * from "./examenPiesShow.vue?vue&type=script&lang=js"
import style0 from "./examenPiesShow.vue?vue&type=style&index=0&id=e81301cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81301cc",
  null
  
)

export default component.exports